import { Box } from "@mui/material";
import  {  useState } from "react";

// call page
import CostingManagementMenu from "../features/costing/Menu";
import { Navigate } from "react-router-dom";

import CostingModule from "../features/costing/CostingView";
import PowerConsumptionModule from "../features/costing/power/consumption";




const CostingManagement = () => {


    const [activePage, setActivePage] = useState('ViewMainPage');
   

    const SetActive = (page) => {
        setActivePage(page);
    }

    const handleBackWinderMachineEntry = () => {
        setActivePage('ViewMainPage');
    }
    const handleBackDashboard = () => {
        Navigate("/");
    }






    return (


        <Box position="relative">

            {activePage === "ViewMainPage" && (<CostingManagementMenu
                SetActive={SetActive} handleBackDashboard={handleBackDashboard}
            />

            )}


            {activePage === "costing" && (
                <CostingModule />
            )}

            {activePage === "power-consumption" && (
                <PowerConsumptionModule handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

        </Box>
    );
};
export default CostingManagement;